module.exports = __webpack_public_path__ + "img/g4.517d112e.png";